import { render } from "./a_bmc.vue?vue&type=template&id=0ab21fdc"
import script from "./a_bmc.vue?vue&type=script&lang=js"
export * from "./a_bmc.vue?vue&type=script&lang=js"

import "./a_bmc.vue?vue&type=style&index=0&id=0ab21fdc&lang=less"
script.render = render

export default script